import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { SuperscriptDecoration } from './../../ricos-schema/next-schema/generated/ricos_document.js';
import type { NodeViewDecorator } from './../../ricos-types/index.js';

const decorator = (element: JSX.Element, superscriptDecoration: SuperscriptDecoration) => {
  const { superscriptData } = superscriptDecoration;
  const isSuperscript = typeof superscriptData === 'undefined' || superscriptData;
  return isSuperscript ? <sup key={`superscript-${element?.key}`}>{element}</sup> : element;
};

const SuperscriptDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.SUPERSCRIPT),
  decorate: ({ element, node }) => {
    const superscriptDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.SUPERSCRIPT
    ) as SuperscriptDecoration;
    return decorator(element as JSX.Element, superscriptDecoration);
  },
};

export default SuperscriptDecorator;
